import type { JSX } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { VerifyRoute } from './VerifyRoute';
import { OnboardLayout } from '@/Layouts';
import { Login } from '@/Pages';

export const AuthRoutes = (): JSX.Element => {
  return (
    <Routes>
      <Route element={<VerifyRoute needAuth={false} element={<OnboardLayout />} />}>
        <Route path='/' element={<VerifyRoute needAuth={false} element={<Login />} />} />
        <Route
          path='/login'
          element={<VerifyRoute needAuth={false} element={<Navigate to='/' />} />}
        />
        {/* Catch all - redirect to login */}
        <Route path='*' element={<Navigate to='/' replace />} />
      </Route>
    </Routes>
  );
};
